import { v2Api } from './v2Client';

const get = (url, config) => v2Api.get(url, config).then((r) => r.data);
const post = (url, body) => v2Api.post(url, body).then((r) => r.data);

export const adminNotificationsService = {
  send: (payload) => post('/AdminNotifications/send', payload),
  history: (take = 50) => get('/AdminNotifications/history', { params: { take } }),
};
